const hotels = {
  accommodation: "Κατάλυμα", // translated
  hotel: "Ξενοδοχειο", // translated
  hotels: "Ξενοδοχεία", // translated
  back: "Πίσω", // translated
  rooms: "Δωμάτια", // translated
  viewPictures: "Προβολή εικόνων", // translated
  showMore: "Δείτε περισσότερα", // translated
  bookingInformation: "Πληροφορίες κράτησης", // translated
  cancellationPolicy: "Πολιτική ακύρωσης", // translated
  from: "Από", // translated
  to: "Προς την", // translated
  cancellationIs: "ακύρωση είναι", // translated
  free: "Ελεύθερος", // translated
  chargeableWithFeeOf: "χρεώνεται με χρέωση του", // translated
  prebook: "Προβιβλίο", // translated
  guests: "Καλεσμένοι", // translated
  payment: "Πληρωμή", // translated
  byClicking: "Κάνοντας κλικ", // translated
  next: "Επόμενο", // translated
  youAreAgreeingToOur: "συμφωνείτε με το δικό μας", // translated
  termsAndConditions: "Οροι και Προϋποθέσεις", // translated
  previous: "Προηγούμενος", // translated
  cancel: "Ματαίωση", // translated
  mealPlan: "Πρόγραμμα Γευμάτων", // translated
  roomType: "Τύπος δωματίου", // translated
  description: "Περιγραφή", // translated
  readLess: "Διαβάστε Λιγότερα", // translated
  readMore: "Διαβάστε περισσότερα", // translated
  facilities: "Εγκαταστάσεις", // translated
  viewLess: "Προβολή Λιγότερο", // translated
  viewMore: "Δείτε περισσότερα", // translated
  less: "πιο λιγο", // translated
  more: "περισσότερο", // translated
  notAvailable_short: "N/A", // translated
  backToHotelList: "Επιστροφή στη λίστα ξενοδοχείων", // translated
  viewOnMap: "Προβολή στο χάρτη", // translated
  sleeps: "Κοιμάται", // translated
  adults: "Ενήλικες", // translated
  yearsOld: "χρονών", // translated
  type: "Τύπος", // translated
  bedding: "Κλινοσκεπάσματα", // translated
  selectRoom: "Επιλέξτε δωμάτιο", // translated
  selectRooms: "Επιλέξτε Δωμάτια", // translated
  city: "Πόλη", // translated
  checkIn: "Ελεγχος εισιτηρίου", // translated
  checkOut: "Ολοκλήρωση αγοράς", // translated
  date: "Ημερομηνία", // translated
  dates: "Ημερομηνίες", // translated
  persons: "Πρόσωπα", // translated
  stillOnTrialQuestionToUpgrade: "Ωχ! Φαίνεται ότι είστε ακόμα σε δοκιμαστική συνδρομή. Πρέπει να είστε επιβεβαιωμένο μέλος για να κάνετε κρατήσεις. Θέλετε να αναβαθμίσετε τώρα;", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "Ωχ! Φαίνεται ότι δεν έχετε εγγραφεί ακόμα. Πρέπει να είστε επιβεβαιωμένο μέλος για να κάνετε κρατήσεις. Θέλετε να αναβαθμίσετε τώρα;", // translated
  completeProfile: "Συμπληρώστε πρώτα το προφίλ χρήστη σας", // translated
  upgrade: "Αναβαθμίζω", // translated
  close: "Κλείσε", // translated
  viewDetails: "Δείτε λεπτομέρειες", // translated
  name: "Ονομα", // translated
  rating: "Εκτίμηση", // translated
  budget: "Προϋπολογισμός", // translated
  orderBy: "Ταξινόμηση κατά", // translated
  priceLowestFirst: "Τιμή (πρώτα η χαμηλότερη)", // translated
  priceHighestFirst: "Τιμή (πρώτα η υψηλότερη)", // translated
  ratingLowestFirst: "Βαθμολογία (πρώτα η χαμηλότερη)", // translated
  ratingHighestFirst: "Βαθμολογία (πρώτα η υψηλότερη)", // translated
  starRatingAndPrice: "Αξιολόγηση με αστέρια και τιμή", // translated
  biggestSavingsFirst: "Πρώτα η μεγαλύτερη εξοικονόμηση", // translated
  select: "Επιλέγω", // translated
  reset: "Επαναφορά", // translated
  apply: "Ισχύουν", // translated
  filterBy: "Φιλτράρισμα κατά", // translated
  myProfile: "Το ΠΡΟΦΙΛ μου", // translated
  login: "Σύνδεση", // translated
  roomOnly: "ΔΩΜΑΤΙΟ ΜΟΝΟ", // translated
  bedAndBreakfast: "ΚΡΕΒΑΤΙ", // translated
  halfBoard: "Ημιδιατροφή", // translated
  fullBoard: "Πλήρης διατροφή", // translated
  allInclusive: "Ολων συμπεριλαμβανομένων", // translated
  filter: "Φίλτρο", // translated
  mapView: "Προβολή χάρτη", // translated
  results: "Αποτελέσματα", // translated
  listView: "Προβολή λίστας", // translated
  newSearch: "Νέα αναζήτηση", // translated
  editSearch: "Επεξεργασία αναζήτησης", // translated
  all: "Ολα", // translated
  multiple: "Πολλαπλούς", // translated
  editProfile: "Επεξεργασία προφίλ", // translated
  backToHotelsList: "Επιστροφή στη λίστα ξενοδοχείων", // translated
  roomName: "Ονομα δωματίου", // translated
  mealType: "Τύπος Γεύματος", // translated
  freeCancellation: "Δωρεάν ακύρωση", // translated
  yes: "Ναί", // translated
  no: "Οχι", // translated
  filters: "Φίλτρα", // translated
  cancellationNonRefundable: "Η ακύρωση δεν επιστρέφεται", // translated
  hotelRating: "Βαθμολογία ξενοδοχείου", // translated
  any: "Οποιος", // translated
  off: "Μακριά από", // translated
  performNewSearch: "Πραγματοποιήστε μια νέα αναζήτηση", // translated
};


export default hotels;
